import React, { useState, useEffect } from 'react';
import decode from 'jwt-decode';

import Loader from '../components/Loader';
import { logoutLocally, loginLocally, setUser, setUsersFollow } from '../actions/auth';
import { getUserProfile, getUserFollower, getMe } from '../services/ProfileService';
import { useDispatch } from 'react-redux';
import { createUseStyles } from 'react-jss';

export interface AuthProviderProps { }

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    const token = localStorage.getItem('loginToken');
    if (token != null) {
      loginLocally(token);
      (async () => {
        try {
          const user = await getMe();
          const usersFollow = await getUserFollower()
          dispatch(setUser(user));
          console.log(usersFollow)
          dispatch(setUsersFollow(usersFollow));
        } catch (e) {
          logoutLocally();
        }
        setLoading(false);
      })();
    } else {
      logoutLocally();
      setLoading(false);
    }
  }, [dispatch]);

  return (
    <Loader className={classes.loader} center loading={loading}>
      {() => <>{children}</>}
    </Loader>
  );
};

const useStyles = createUseStyles({
  loader: {
    paddingTop: '50vh',
  },
});

export default AuthProvider;
